import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Auth from "@/pages/Auth";
import Landing from "@/pages/Landing";
import CommandCenter from "@/pages/CommandCenter";
import LovedOnes from "@/pages/LovedOnes";
import Cards from "@/pages/Cards";
import Drafts from "@/pages/Drafts";
import Vault from "@/pages/Vault";
import Circles from "@/pages/Circles";
import Boutique from "@/pages/Boutique";
import VibeFeed from "@/pages/VibeFeed";
import Captain from "@/pages/Captain";
import ImpactReport from "@/pages/ImpactReport";
import Membership from "@/pages/Membership";
import CoSign from "@/pages/CoSign";
import Lounge from "@/pages/Lounge";
import RoyalToast from "@/pages/RoyalToast";
import Keepsake from "@/pages/Keepsake";
import ExperienceHub from "@/pages/ExperienceHub";
import Deliveries from "@/pages/Deliveries";
import Subscription from "@/pages/Subscription";
import GiftWall from "@/pages/GiftWall";
import Arrangements from "@/pages/Arrangements";
import Profile from "@/pages/Profile";
import Fulfillment from "@/pages/Fulfillment";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Dmca from "@/pages/Dmca";
import About from "@/pages/About";
import AppleAuthComplete from "@/pages/AppleAuthComplete";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const PublicOnly = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Loading…</div>;
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
};

function App() {
  useEffect(() => {
    document.documentElement.classList.remove("dark");
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<PublicOnly><Auth /></PublicOnly>} />
            <Route path="/forgot-password" element={<PublicOnly><ForgotPassword /></PublicOnly>} />
            <Route path="/reset-password" element={<PublicOnly><ResetPassword /></PublicOnly>} />
            <Route path="/cosign/:token" element={<CoSign />} />
            <Route path="/circle/:token" element={<Lounge />} />
            <Route path="/toast/:token" element={<RoyalToast />} />
            <Route path="/keepsake/:token" element={<Keepsake />} />
            <Route path="/experience/:token" element={<ExperienceHub />} />
            {/* One-Tap Sovereign Auth — lands the redirect-flow Sign in with Apple session */}
            <Route path="/auth/apple/complete" element={<AppleAuthComplete />} />
            {/* Public Legal Shield — readable without login, for App Store / compliance review */}
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/dmca" element={<Dmca />} />
            <Route path="/about" element={<About />} />
            <Route path="/dashboard" element={<Protected><CommandCenter /></Protected>} />
            {/* /wallet — the Maison Funding Station's Stripe success_url/cancel_url land
                here; renders the same dashboard (Wallet section lives at the top of it). */}
            <Route path="/wallet" element={<Protected><CommandCenter /></Protected>} />
            <Route path="/loved-ones" element={<Protected><LovedOnes /></Protected>} />
            <Route path="/cards" element={<Protected><Cards /></Protected>} />
            <Route path="/drafts" element={<Protected><Drafts /></Protected>} />
            <Route path="/vault" element={<Protected><Vault /></Protected>} />
            <Route path="/circles" element={<Protected><Circles /></Protected>} />
            <Route path="/boutique" element={<Protected><Boutique /></Protected>} />
            <Route path="/feed" element={<Protected><VibeFeed /></Protected>} />
            <Route path="/captain" element={<Protected><Captain /></Protected>} />
            <Route path="/impact" element={<Protected><ImpactReport /></Protected>} />
            <Route path="/membership" element={<Protected><Membership /></Protected>} />
            <Route path="/deliveries" element={<Protected><Deliveries /></Protected>} />
            <Route path="/subscription" element={<Protected><Subscription /></Protected>} />
            <Route path="/gift-wall" element={<Protected><GiftWall /></Protected>} />
            <Route path="/arrangements" element={<Protected><Arrangements /></Protected>} />
            <Route path="/profile" element={<Protected><Profile /></Protected>} />
            <Route path="/admin/fulfillment" element={<Protected><Fulfillment /></Protected>} />
            <Route path="/" element={<Landing />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
